/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type internal_handlers_reconciliation_SubsidyAllocationVariance = {
    disposition: internal_handlers_reconciliation_SubsidyAllocationVariance.disposition;
    reasonCode: internal_handlers_reconciliation_SubsidyAllocationVariance.reasonCode;
};
export namespace internal_handlers_reconciliation_SubsidyAllocationVariance {
    export enum disposition {
        ROUNDING_WRITEOFF = 'rounding_writeoff',
        RESIDUAL = 'residual',
        ON_ACCOUNT = 'on_account',
        REMITTANCE_LEVEL = 'remittance_level',
    }
    export enum reasonCode {
        CITY_ROUNDING = 'city_rounding',
        KONSOLIDATION = 'konsolidation',
        INTERMEDIATE_BILLING = 'intermediate_billing',
        STORNO = 'storno',
        OTHER = 'other',
    }
}

